<template>
  <v-container pt-0 fluid>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <sorter @sort="sortByUser" />
      </v-flex>
      <v-flex xs12>
        <error-message ref="errorDialog" />
      </v-flex>
    </v-layout>
    <template v-if="graphList.length > 0">
      <v-layout row wrap>
        <v-flex xs12>
          <template v-for="(graph, index) in graphList">
            <graph-card :key="index" :payload="graph"></graph-card>
            <v-divider
              v-if="index < graphList.length - 1"
              :key="'divider' + index"
              class="divider"
            ></v-divider>
          </template>
        </v-flex>
      </v-layout>
    </template>
    <v-card flat v-else>
      <not-found>急上昇中のグラフはまだありません</not-found>
    </v-card>
  </v-container>
</template>

<script>
// グラフ部品
import GraphCard from "@/views/home/GraphCard.vue";
import NotFound from "@/components/parts/404.vue";
import Sorter from "@/components/Sorter.vue";
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  data() {
    return {
      graphList: () => []
    };
  },
  components: {
    GraphCard,
    NotFound,
    Sorter,
    ErrorMessage
  },
  mounted() {
    this.getHotGraphs();
  },
  watch: {
    "$route.path": function() {
      this.getHotGraphs();
    }
  },
  methods: {
    getHotGraphs() {
      this.$http
        .get("/v1/graphs/ranking", {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.graphList = res.data;
        })
        .catch(error => {
          this.graphList = [];
          this.$refs.errorDialog.setMessage(
            "急上昇グラフの取得に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    // sortの比較関数は a > bの時は正数を、a < bの時は負数を返す。
    // [0]と[1]を比較して[0]の方が大きければ[0]と[1]を入れ替えるのを繰り返すので a-bの引き算でソートができる。
    // 降順の場合は最後のorderで-1を掛けてやれば逆順になる。
    sortByUser(sortKey, order) {
      this.graphList.sort((a, b) => {
        return (a[sortKey] - b[sortKey]) * order;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.divider {
  width: 100%;
  margin: 20px 0;
  border: none;
  border-top: dashed 1px #ff9933;
}
</style>
